import { Item } from '@factorialco/deprecated-design-system'
import { Form } from 'factorial-form'
import {
  A3InnuvaCnoOccupationDocument,
  A3innuvaContractsCnoOccupationFragment,
} from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import DropdownSearchBar from 'modules/core/components/DropdownSearchBar'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { SpanishContractData } from 'modules/contracts/hooks/useFetchSpanishContractData'
import {
  cnoOccupationsToOptions,
  fullName,
} from 'modules/payroll_integrations_a3innuva/lib/a3innuvaHelpers'

interface Props {
  form: Form
  spanishContractData: SpanishContractData
  legalEntityId: string
}

const CnoOcuppationField = ({ form, spanishContractData, legalEntityId }: Props) => {
  const session = useCurrentSession()
  const cnoOccupationName = form.get('es_cno_occupation_payroll_integration_name').value
  const cnoOccupationCode = form.get('es_cno_occupation_payroll_integration_code').value
  const cnoOccupationId = form.get('es_cno_occupation_id').value
  const spainCnoOccupation = cnoOccupationId
    ? spanishContractData.cnoOccupations.get(String(cnoOccupationId))
    : null

  const setCurrentCnoOccupation = (a3CnoOccupations: A3innuvaContractsCnoOccupationFragment[]) => {
    const currentCnoOccupation = a3CnoOccupations.find(
      ({ name }) => name === spainCnoOccupation?.attributes.name
    )

    if (currentCnoOccupation) {
      form.setValues({
        es_cno_occupation_payroll_integration_code: currentCnoOccupation.code,
        es_cno_occupation_payroll_integration_name: currentCnoOccupation.name,
      })
    }
  }

  const isFormInitialized = () => {
    if (!form.has('es_cno_occupation_payroll_integration_name')) return false
    return (
      form.get('es_cno_occupation_payroll_integration_name') === spainCnoOccupation?.attributes.name
    )
  }

  const { data: cnoOccupationStepData, loading } = useQuery(A3InnuvaCnoOccupationDocument, {
    variables: {
      companyId: session.company.id,
      currentUserId: session.access.userId,
      legalEntityId,
    },
  })
  const a3innuvaCnoOccupations =
    cnoOccupationStepData?.payrollIntegrationsA3innuva.cnoOccupations ?? []

  if (!loading && !isFormInitialized()) {
    setCurrentCnoOccupation(a3innuvaCnoOccupations)
  }

  const options = cnoOccupationsToOptions(a3innuvaCnoOccupations)

  const labelNotFound = () => {
    return options.length
      ? i18n.t('contract_versions.forms.contract_extra_information.a3innuva.cno_not_found')
      : i18n.t('contract_versions.forms.contract_extra_information.a3innuva.label_not_found')
  }

  const onCnoChanged = (option: Item) => {
    const selectedCno = a3innuvaCnoOccupations.find(({ code }) => code === option.value)
    form.setValues({
      es_cno_occupation_payroll_integration_code: selectedCno?.code,
      es_cno_occupation_payroll_integration_name: selectedCno?.name,
      es_cno_occupation_id: undefined,
    })
  }

  return (
    <DropdownSearchBar
      name={fullName(cnoOccupationCode, cnoOccupationName)}
      label={i18n.t('contract_versions.flows.fix.steps.legal_and_extras.cno_occupation.label')}
      onSelect={onCnoChanged}
      labelNotFound={labelNotFound()}
      data={options}
      searchLabel={i18n.t(
        'contract_versions.forms.contract_extra_information.a3innuva.search_label'
      )}
      loading={loading}
      popoverWidth="s400"
      ellipsis={false}
    />
  )
}

export default observer(CnoOcuppationField)
